/* eslint-disable react/jsx-no-bind */
/* eslint-disable arrow-body-style */
import { ArrowLeftCircleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/solid";
import { Button, Container, Nav } from "react-bootstrap";
import CheckmarkIcon from "../../icons/CheckmarkIcon";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";


const ReportReviewNav = ({ handleClose, activeSection, furthestSection }) => {
	return (
		<Container className="profile__nav bg-primary">
			<div className="logo-container profile__sidebar-section align-items-center d-flex justify-content-between">
				<img 
					alt="LOGO"
					className="logo"
					height="152"
					src="/eqqo_logo.png"
					width="472"
				/>
				<Button className="nav-menu-button" onClick={handleClose}>X</Button>
			</div>
			<Nav as="nav" className="report-nav-list review profile__sidebar-section flex-column fs-16" defaultActiveKey="/report/introduction">
				<Nav.Item>
					<NavLink 
						className={`nav-link ${ activeSection === 1 ? 'active' : '' } ${ furthestSection > 1 ? 'complete' : '' }`}
						disabled={furthestSection < 1}
						to="/report/introduction"
					>
						<span className="nav-step">
							1
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Introduction</span>
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 2 ? 'active' : '' } ${ furthestSection > 2 ? 'complete' : '' }`}
						disabled={furthestSection < 2}
						to="/report/emotions"
					>
						<span className="nav-step">
							2
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Emotions</span>
					</NavLink>
				</Nav.Item>
				{/* <Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 3 ? 'active' : '' } ${ furthestSection > 3 ? 'complete' : '' }`}
						disabled={furthestSection < 3}
						to="/report/positive-negative">
						<span className="nav-step">
							3
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Positive-Negative</span>
					</NavLink>
				</Nav.Item> */}
				<Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 3 ? 'active' : '' } ${ furthestSection > 3 ? 'complete' : '' }`}
						disabled={furthestSection < 3}
						to="/report/self-other">
						<span className="nav-step">
							3
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Self-Other</span>
					</NavLink>
				</Nav.Item>
				{/* <Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 5 ? 'active' : '' } ${ furthestSection > 5 ? 'complete' : '' }`}
						disabled={furthestSection < 5}
						to="/report/thoughts-wants-feelings">
						<span className="nav-step">
							5
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Thoughts / Wants / Feelings</span>
					</NavLink>
				</Nav.Item> */}
				{/* <Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 6 ? 'active' : '' } ${ furthestSection > 6 ? 'complete' : '' }`}
						disabled={furthestSection < 6}
						to="/report/empathy-accuracy">
						<span className="nav-step">
							6
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Empathy Accuracy</span>
					</NavLink>
				</Nav.Item> */}
				<Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 4 ? 'active' : '' } ${ furthestSection > 4 ? 'complete' : '' }`}
						disabled={furthestSection < 4}
						to="/report/empathy-compassion">
						<span className="nav-step">
							4
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Empathy Compassion</span>
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 5 ? 'active' : '' } ${ furthestSection > 5 ? 'complete' : '' }`}
						disabled={furthestSection < 5}
						to="/report/relationship-strategies">
						<span className="nav-step">
							5
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Relationship Strategies</span>
					</NavLink>
				</Nav.Item>
				<Nav.Item>
					<NavLink
						className={`nav-link ${ activeSection === 6 ? 'active' : '' } ${ furthestSection > 6 ? 'complete' : '' }`}
						disabled={furthestSection < 6}
						to="/report/summary">
						<span className="nav-step">
							6
							<CheckmarkIcon />
						</span>
						<span className="nav-step-label">Summary</span>
					</NavLink>
				</Nav.Item>
			</Nav>
			<div className="profile__sidebar-section">
				<NavLink className="nav-link text-white" to="/profile/help">
					<QuestionMarkCircleIcon />
					Help
				</NavLink>
			</div>
			<Nav.Item className="mt-auto profile__sidebar-section">
				<NavLink className="nav-link text-white" to="/logout">
					<ArrowLeftCircleIcon height={24} width={24} />
					Logout
				</NavLink>
			</Nav.Item>
		</Container>
	);
};


ReportReviewNav.propTypes = {
	activeSection: PropTypes.number,
	furthestSection: PropTypes.number,
	handleClose: PropTypes.func
};

ReportReviewNav.defaultProps = {
	activeSection: 1,
	furthestSection: 1,
	handleClose: null
}

export default ReportReviewNav;
